export const defaultRegistryUrl = 'https://registry.npmjs.org';
